import styled from "styled-components";

export const SelectContainer = styled.div`
  .caelor-custom-select__control {
    height: 40px;
    background-color: ${({ theme }) => theme.bg.primary};
    border-radius: 8px;
    box-sizing: border-box;
    border: none;
    width: 100%;
    font-size: 13.3333px;
    color: ${({ theme }) => theme.bg.black};

    &:focus {
      outline: none;
    }

    &:hover {
      background-color: ${({ theme }) => theme.border.black10};
    }

    .caelor-custom-select__placeholder,
    .caelor-custom-select__single-value {
      color: ${({ theme }) => theme.bg.black} !important;
    }
  }

  .caelor-custom-select__option {
    font-size: 13.3333px;
    color: ${({ theme }) => theme.bg.black};
    box-shadow: none;
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) => theme.border.black10};
    }
  }
  .caelor-custom-select__option--is-selected {
    background-color: ${({ theme }) => theme.bg.primary};
  }
  .caelor-custom-select__option--is-focused {
    background-color: ${({ theme }) => theme.bg.secondary};
  }
`;
